import { ColDef, ColGroupDef } from '../entities/colDef';

export interface IColumnToolPanel {
  expandColumnGroups(groupIds?: string[]): void;
  collapseColumnGroups(groupIds?: string[]): void;
  setColumnLayout(colDefs: (ColDef | ColGroupDef)[]): void;
  syncLayoutWithGrid(): void;
  setPivotModeSectionVisible(visible: boolean): void;
  setRowGroupsSectionVisible(visible: boolean): void;
  setValuesSectionVisible(visible: boolean): void;
  setPivotSectionVisible(visible: boolean): void;
}
